import React from "react";
import ReactDOM from "react-dom/client";

// Street-Lawyer UK serves a self-contained static promotional site as the
// frontend root (public/index.html) with its OWN dark theme and styles.
// That page has no React #root element. We must therefore avoid statically
// importing the template's global stylesheet ("@/index.css") or the React
// App here, because those imports execute at module load and would inject the
// template's light-theme Tailwind reset over the promo page — changing its
// colours. We only load the React app (and its CSS) lazily when an actual
// #root mount point exists.
const rootEl = document.getElementById("root");
if (rootEl) {
  Promise.all([
    import("@/index.css"),
    import("@/App"),
    import("@tanstack/react-query"),
  ]).then(([, appModule, reactQuery]) => {
    const App = appModule.default;
    const { QueryClient, QueryClientProvider } = reactQuery;
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 60_000,
          refetchOnWindowFocus: false,
        },
      },
    });
    ReactDOM.createRoot(rootEl).render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </React.StrictMode>,
    );
  });
}
